import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../pages/Login/model/authSlice";
import profileSliceReducer from "../entities/Agents/model/agents";
import addObjectSlice from "../entities/AddObject/model/addObjectSlice";
import agentsReducer from "../entities/Agents/model/agents";
import districtsReducer from "../entities/Districts/model/districts";
import residentalsReducer from "../entities/Residentals/modal/residentals";
import contactsReducer from "../entities/Contacts/model/contacts";
import myPropertiesReducer from "../entities/MyProperties/model/myPropertiesSlice";
import propertiesReducer from "../entities/General/model/propertiesSlice";
import filterReducer from "../shared/components/Filter/model/filterSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileSliceReducer,
    addObject: addObjectSlice,
    agents: agentsReducer,
    districts: districtsReducer,
    residentals: residentalsReducer,
    contacts: contactsReducer,
    myProperties: myPropertiesReducer,
    properties: propertiesReducer,
    filter: filterReducer,
  },
});
